//@ts-check

import 'unfetch/polyfill';

import Router from './router';
import pages from './pages';
import Flags from './lib/flags';

const router = new Router(pages.notFound);

// Add routes
router.addRoute('/', pages.home);
router.addRoute('/archiv', pages.archive, [], { page: 'all' });
router.addRoute('/archiv/moje', pages.archive, [], { page: 'mine' });
router.addRoute('/archiv/sledovat/:recId/:clnId/:code', pages.recording, ['code', 'recId', 'clnId']);
router.addRedirect(/^\/platba\/(\d+)\/(\d+)/, (resId, code) => `/platba/r${resId}/${code}`);
router.addRoute('/platba/r:id/:code', pages.payment, ['code', 'id'], { type: 'reservation' });
router.addRoute('/platba/k:id/:code', pages.payment, ['code', 'id'], { type: 'credits' });
router.addRoute('/platba/v:id/:code', pages.payment, ['code', 'id'], { type: 'recording' });
router.addRoute('/heslo/:clnId/:code', pages.password, ['code', 'clnId']);
router.addRoute('/overeni/:clnId/:code', pages.verify, ['code', 'clnId']);
router.addRoute('/zrusit/:resId/:code', pages.cancel, ['code', 'resId']);
router.addRoute('/vysilani/:evrId/:clnId/:code', pages.stream, ['code', 'evrId', 'clnId']);

const allowedValues = {
    on: true,
    off: false
};
router.nav.on('/flag/:flag/:value', (params) => {
    let { flag, value } = params;

    // Invalid flag
    if (!Flags.isValid(flag)) {
        return router.showNotFound();
    }

    // Invalid flag value, turn off
    if (!allowedValues.hasOwnProperty(value)) {
        value = 'off';
    }

    // Save flag value
    Flags.set(flag, allowedValues[value]);

    // Go to home
    location.href = '/';
});

router.resolve();